























import { Vue, Component, Prop, Provide } from 'vue-property-decorator';

import Layout from '@/layouts/Default.vue';
import TitlePage from '@/components/Title.vue';
import CalendarDoctor from '@/components/calendar/CalendarDoctor.vue'
import CalendarRepository from '@/components/calendar/CalendarRepository.vue';

@Component({
    components: {
        Layout,
        TitlePage,
        CalendarRepository,
        CalendarDoctor,
    },
    inheritAttrs: false,
})
export default class CalendarDoctorPage extends Vue {
    @Prop({ required: true }) doctorId!: number;
    @Provide() hasActions = false
}
